import React, {useCallback, useEffect, useState} from "react";
import {useLocation} from 'react-router-dom';
import {useTranslation} from "react-i18next";
//MUI
import {Box, Button, Divider, Stack} from "@mui/material";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';

import UDataGrid from "../../components/mui/UDataGrid";
import UBreadCrumbs from "../../components/mui/UBreadCrumbs";
import USelectBox from "../../components/mui/USelectBox";
import UTextField from "../../components/mui/UTextField";
import UButton from "../../components/mui/UButton";
import UDatePickers from "../../components/mui/UDatePickers";
import UTable from "../../components/mui/UTable";
import UAuthButton from "../../components/mui/UAuthButton";

import {API, PAGE, AGENT} from "../../config";
import {
    getAPI
    , fni18n
} from "../../services/commonService";
import AuthenticationService from "../../pages/auth/AuthenticationService";
import axios from "axios";
import {saveAs} from 'file-saver';

export default function RemotePage() {
    const {t} = useTranslation();

    const userLoginId = AuthenticationService.getLoggedInUserID();
    const [branchs, setBranch] = useState([]);
    const [models, setModels] = useState([]);
    const [command, setCommands] = useState([]);
    const [rows, setRows] = useState([]);
    const [search, setSearch] = useState({
        // storeCd: "N/A",
    });
    const [machineNo, setMachineNo] = useState([]);
    const [retailers, setRetailers] = useState([]);
    const [selectedCommands, setSelectedCommands] = useState({});
    const [isFirstLoad, setIsFirstLoad] = useState(true);

    const onSearchChange = (e, machKey) => {
        let {name, value} = e.target;
        setSearch({
            ...search,
            [name]: value === 'ALL' ? '' : value,
        })
        if (name === "bizTy") {
            loadComboBoxBranch(value);
        }
        //지점선택 후 기번 가져오기
        if (name === "storeCd") {
            loadComboBoxMachineNo(value);
        }

        setSelectedCommands({
            ...selectedCommands,
            [machKey]: value // rowId로 행을 구분
        });
    }

    const fnLog = async (ip) => {
        if (!ip || ip === "undefined" || typeof ip === "undefined") {
            alert("IP " + t("정보가 존재하지 않습니다."));
            return;
        }
        const token = Math.floor(Math.random() * 1000000) + 1;
        const strUrl = `https://${ip}:${AGENT.PORT}/svc/if/setToken?token=${token}`;

        try {
            await getAPI(strUrl)
                .then((res) => {
                    if (res && res.status === 200) {
                        const logUrl = `https://${ip}:${AGENT.PORT}/drive/d/LOG/?i=${token}`;
                        const element = document.createElement('a');
                        element.href = logUrl;
                        element.target = "_blank";
                        document.body.appendChild(element);
                        element.click();
                    } else {
                        return alert(`${ip} ` + t("로그") + " " + t("정보를 불러올 수 없습니다."));
                    }
                }).catch(e => {
                    return alert(`${ip} ` + t("로그") + " " + t("정보를 불러올 수 없습니다."));
                });
        } catch (e) {
            return alert(e.message);
        }
    }

    const fnCMD = async (ip, port, command) => {
        if (!ip || ip === "undefined" || typeof ip === "undefined") {
            alert("IP " + t("정보가 존재하지 않습니다."));
            return;
        }
        if (!port || port === "undefined" || typeof port === "undefined") {
            alert("Port " + t("정보가 존재하지 않습니다."));
            return;
        }
        if (!command || command === "undefined" || typeof command === "undefined") {
            alert(t("원격명령을 선택해주세요."));
            return;
        }

        try {
            const token = Math.floor(Math.random() * 1000000) + 1;
            const CmdTokUrl = `https://${ip}:${port}/svc/if/setCMDToken?token=${token}`;

            await getAPI(CmdTokUrl).then((res) => {
                if (res && res.status === 200) {
                    const cmd = command;
                    const CmdkUrl = `https://${ip}:${port}/svc/if/${cmd}?token=${token}`;
                    getAPI(CmdkUrl).then((res2) => {
                        if (res2 && res2.status === 200 && res2.data.length > 0) {
                            alert(res2.data);
                        } else {
                            alert(`${ip} ${cmd}` + t("명령 전송 실패"));
                        }
                    })
                } else {
                    alert(`${ip} ` + t("연결에 실패하였습니다."));
                }
            })
        } catch (e) {
            console.log(e.message);
        }
    }
    const columns = [
        {
            field: 'id',
            headerName: 'No',
            width: 50,
            hide: true,
            align: "center",
            headerAlign: "center",
        },
        {
            field: 'storeCd',
            headerName: '지점번호',
            flex: 1,
            align: "center",
            headerAlign: "center",
        },
        {
            field: 'machId',
            headerName: '기기번호',
            flex: 1,
            align: "center",
            headerAlign: "center",
        },
        {
            field: 'machKndCd',
            headerName: '기종',
            flex: 1,
            align: "center",
            headerAlign: "center",
        },
        {
            field: 'machIp',
            headerName: 'IP',
            flex: 1,
            align: "center",
            headerAlign: "center",
        },
        {
            field: 'machPort',
            headerName: 'PORT',
            flex: 1,
            align: "center",
            headerAlign: "center",
        },
        {
            field: 'command',
            headerName: '명령어',
            flex: 1,
            align: "center",
            headerAlign: "center",
            renderCell: (params) => {
                const machKey = params.rows.machIp + ":" + params.rows.machPort;
                return (
                    <USelectBox
                        name="command"
                        items={command}
                        onItemChange={(e) => onSearchChange(e, machKey)} // 각 행 ID 전달
                        value={selectedCommands[machKey] || 'SELECT'}
                    />
                );
            }
        },
        {
            field: 'remoteCntrl',
            headerName: '원격제어',
            flex: 1,
            align: "center",
            headerAlign: "center",
            renderCell: (params) => {
                let machKey = params.rows.machIp + ":" + params.rows.machPort;
                return (
                    <UButton
                        variant="outlined"
                        onButtonClick={() => fnCMD(`${params.rows.machIp}`, `${params.rows.machPort}`, selectedCommands[machKey])}
                    >
                        실행
                    </UButton>
                );
            },
        },
        {
            field: 'log',
            headerName: '로그',
            flex: 1,
            align: "center",
            headerAlign: "center",
            renderCell: (params) =>
                (
                    <UButton
                        variant="outlined"
                        onButtonClick={() => fnLog(`${params.rows.machIp}`)}
                    >
                        보기
                    </UButton>
                ),
        },
    ];

    //화면 로드 시
    useEffect(() => {
        const getLoadData = async () => {
            try {
                await Promise.all([
                    loadComboBoxBranchGroup(),
                    loadComboBoxBranch(),
                    loadComboBoxModel(),
                    loadComboBoxRemoteCMD()
                ]);
            } catch (e) {
                console.error('초기 로딩 실패:', e.message);
            }
        };
        getLoadData();
    }, []);
    useEffect(() => {
        if (!isFirstLoad) return;
        if (search.storeCd) {
            loadDataGrid(); 
            setIsFirstLoad(false);
        }
    }, [search]);

    const clearSearchVal = ()=>{
        setSearch({
            ...search,
            ['storeCd']: 'N/A',
        });
        setMachineNo([]);
    }

    // 콤보박스 데이터
    const loadComboBoxBranchGroup = async () => {
        try {
            const res = await getAPI(API.COMMON.BRANCH_GROUP, {userId: userLoginId,branchGroupTy: "BIZ_TY",useYn:"Y"});
            const _inputData = res.data.result.map((m) => ({
                cd: m.id,
                name: m.branchGroupNm,
            }));
            setRetailers(_inputData);
            // await loadComboBoxBranch(_inputData[0].cd);
        } catch (e) {
            console.error(e.message);
        }
    };
    const loadComboBoxBranch = async (param) => {
        try {
            const res = await getAPI(API.COMMON.BRANCH, { userId: userLoginId, bizTy:param, });
            const _inputData = res.data.result.map((m) => ({
                    cd: m.storeCd,
                    name: m.storeNm,
                })
            );
            setBranch(_inputData);
            if (_inputData.length > 0) {
                setSearch({
                    ...search,
                    ['storeCd']: _inputData[0].cd,
                })
                await loadComboBoxMachineNo(_inputData[0].cd);
            } else {
                clearSearchVal()
            }
        } catch (e) {
            console.error(e.message);
        }
    };
    const loadComboBoxMachineNo = async (branch) => {
        try {
            const res = await getAPI(API.COMMON.MACHINE + branch);
            const _inputData = res.data.result.map((m) => ({
                    cd: m.machId,
                    name: m.machId,
                })
            );
            setMachineNo(_inputData);
        } catch (e) {
            console.error(e.message);
        }
    };
    const loadComboBoxModel = async () => {
        try {
            const res = await getAPI(API.COMMON.MODEL);
            const _inputData = res.data.result.map((m) => ({
                    cd: m.machKndCd,
                    name: m.machKndCd,
                })
            );
            setModels(_inputData);
        } catch (e) {
            console.error(e.message);
        }
    };
    const loadComboBoxRemoteCMD = async () => {
        try {
            const res = await getAPI(API.COMMON.REMOTE_CMD);
            const _inputData = res.data.result.map((m) => ({
                    cd: m.cdNm,
                    name: m.cdNm,
                })
            );
            setCommands(_inputData);
        } catch (e) {
            console.error(e.message);
        }
    };
    //데이터그리드
    const loadDataGrid = async () => {
        await getAPI(API.SYSTEM.REMOTE, search).then((res) => {
            setRows(res.data.result);
        });
    }

    //DataGrid에서 row 선택 시 
    function onSelectedRow(row) {
        // console.log(row);
    };

    function onButtonClick(dvsn) {
        if (dvsn === "조회") {
            loadDataGrid(search);
        }
    };

    const downZipLog = async () => {
        try {
            const token = localStorage.getItem("token");
            // await getAPI(API.SYSTEM.REMOTE_DOWN,params).then((res) => {
            await axios.get(API.SYSTEM.REMOTE_DOWNLOG, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + token
                },
                responseType: 'arraybuffer'
            }).then((res) => {
                const blob = new Blob([res.data], {type: "application/zip"});
                const today = new Date();
                const year = today.getFullYear();
                const month = (today.getMonth() + 1).toString().padStart(2, '0');
                const day = today.getDate().toString().padStart(2, '0');
                const yyyymmdd = `${year}${month}${day}`;

                saveAs(blob, "SERVERLOGS_" + yyyymmdd + ".zip");
                /* const url = window.URL.createObjectURL(blob);
                 console.log(url);
                 const link = document.createElement('a');
                 console.log(link);
                 link.href = url;
                 link.setAttribute('download', `logsFile.zip`); // 파일명 설정
                 document.body.appendChild(link);
                 link.click();*/
            });
        } catch (e) {
            console.error(e.message);
        }
    };

    return (
        <div className="main-container">
            <div className="header">
                {/* 상단메뉴명 */}
                <UBreadCrumbs
                    title={"시스템관리"}
                    subtitle={"원격제어관리"}
                />
            </div>

            <Box className="contents">
                {/* 조회조건 */}
                <TableContainer className="table-container">
                    <Table className="table" size="small">
                        <TableBody>
                            <TableRow className="table-row-header">
                                <TableCell className="table-cell-title">{fni18n("고객사")}</TableCell>
                                <TableCell className="table-cell">
                                    <USelectBox
                                        name="bizTy"
                                        items={retailers}
                                        onItemChange={onSearchChange}
                                    />
                                </TableCell>
                                <TableCell
                                    className="table-cell-title">{fni18n('지점')}</TableCell> {/* TODO 조회조건 지점 추가 */}
                                <TableCell className="table-cell">
                                    {/* 점번 선택 */}
                                    <USelectBox
                                        name="storeCd"
                                        items={branchs}
                                        onItemChange={onSearchChange}
                                        defaultValue={search.storeCd}
                                    />
                                </TableCell>
                                <TableCell className="table-cell-title">{fni18n('기기번호')}</TableCell>
                                <TableCell className="table-cell">
                                    <USelectBox
                                        id="machId"
                                        name="machId"
                                        items={machineNo}
                                        onItemChange={onSearchChange}/>
                                </TableCell>
                                <TableCell className="table-cell-title">{fni18n('기종')}</TableCell>
                                <TableCell className="table-cell">
                                    {/* 기번 선택 */}
                                    <USelectBox
                                        name="machKndCd"
                                        items={models}
                                        onItemChange={onSearchChange}
                                    />
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
                <div className="search">
                    <UButton icon="Search" onButtonClick={onButtonClick}>조회</UButton>
                </div>

                {/* 조회 리스트 */}
                <UTable
                    columns={columns}
                    rows={rows}
                    rowPerPage={11}
                    toolbarAdd={
                        <UButton icon="Down" onButtonClick={downZipLog}>서버 로그 다운로드</UButton>
                    }
                />
            </Box>
        </div>
    );
}